import { render } from "./TeoServer.vue?vue&type=template&id=580397e3&scoped=true"
import script from "./TeoServer.vue?vue&type=script&lang=js"
export * from "./TeoServer.vue?vue&type=script&lang=js"

import "./TeoServer.vue?vue&type=style&index=0&id=580397e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580397e3"]])

export default __exports__